import { Button } from '@/components/atoms/NewPcButton';
import { DialogClose } from '@/components/atoms/Dialog';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useAppSelector } from '@/redux/store';
import { useEffect } from 'react';

interface NewPaymentDialogProps {
  isPrePayment?: boolean;
  subscriptionNo: number;
  paymentAmount: number;
}

const ChangeBillKakao = ({
  isPrePayment,
  subscriptionNo,
  paymentAmount,
}: NewPaymentDialogProps) => {
  const { CplatToken } = useAppSelector((state) => state.user);

  // 2. 카카오페이 결제 준비
  const { mutate: readyKakaoPay, isLoading: isPayLoading } = usePost(
    CPLAT_API_ROUTES.paymentReadyForKakaoPay,
  );

  const handleKakaoPay = () => {
    if (!CplatToken) {
      alert('로그인이 필요합니다.');
      return;
    }
    if (!subscriptionNo) {
      alert('멤버십 정보가 없습니다.');
      return;
    }
    readyKakaoPay(
      {
        cplatToken: CplatToken,
        subscriptionNo: subscriptionNo || 23,
        isPrePayment: isPrePayment,
      },
      {
        onSuccess: (res) => {
          const { KakaoPayRequestInfo, KakaoPayResponseInfo } = res.data.data[0];

          localStorage.setItem('kakaoPayRequestInfo', JSON.stringify(KakaoPayRequestInfo));
          localStorage.setItem('kakaoPayResponseInfo', JSON.stringify(KakaoPayResponseInfo));
          localStorage.setItem('subscriptionNo', String(subscriptionNo));
          window.location.href = KakaoPayResponseInfo.NextRedirectPcUrl;
        },
        onError: () => {
          alert('카카오페이 결제 준비에 실패했습니다.');
        },
      },
    );
  };

  return (
    <div className="flex w-full items-center justify-end gap-5">
      <div className="text-gr-900 Body1S16">
        결제 금액 {paymentAmount ? paymentAmount.toLocaleString() : '-'}원
      </div>
      <div className="flex gap-2">
        <DialogClose asChild>
          <Button size="small" variant="line" className="h-[38px] shadow-none">
            취소
          </Button>
        </DialogClose>
        <Button
          size="small"
          isLoading={isPayLoading}
          onClick={handleKakaoPay}
          disabled={isPayLoading || !subscriptionNo}
          className="h-[38px]"
        >
          다음
        </Button>
      </div>
    </div>
  );
};

export default ChangeBillKakao;
